import {Injectable, OnInit} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {CmsHtmlPage} from "./cms-html-page";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {TranslateService} from "../shared/translate.service";

@Injectable({
  providedIn: 'root'
})
export class InfoPageService implements OnInit {

  private startTag = `<style>`;
  private endTag = `</style>`;
  private configDirectory = 'assets/config/';
  private html = '';
  private css = '';

  public static BASE_PREFIX = 'info';

  constructor(private http: HttpClient,
              private translateService: TranslateService) {
  }

  ngOnInit(): void {
  }

  getComponent(url: string, isLogged?: boolean): Observable<CmsHtmlPage> {
    if (url) {
      if (url.endsWith("html")) {
        url = url.substr(0, url.indexOf("html"));
      }

      return this.http.get<CmsHtmlPage[]>(
        `${this.configDirectory}/info-sites/cms.config.json`)
        .pipe(map(cms => cms.find(cm => (cm.loggedOnly === false || cm.loggedOnly === isLogged) && cm.alias === url)));
    }
  }

  getComponents(area: string, isLogged?: boolean): Observable<CmsHtmlPage[]> {
    if (area) {
      return this.http.get<CmsHtmlPage[]>(`${this.configDirectory}/info-sites/cms.config.json`)
        .pipe(map(cms => cms
          .filter(cm => cm.loggedOnly === false || cm.loggedOnly === isLogged)
          .filter(cm => cm.area === area)
          .filter(cm => cm.active === true))
        );
    }
  }

  getInfoPageLabel(url: string): Observable<string> {
    let values = url.split('/');
    return this.getComponent(values[values.length - 1], true).pipe(map(value => value ? value.label : undefined));
  }

  createPage(data: CmsHtmlPage): string {
    this.initPage(data);
    this.translateService.languageChanged.subscribe(() => {
      this.initPage(data);
    });
    return this.startTag + this.css + this.endTag + this.html;
  }

  initPage(data: CmsHtmlPage) {
    this.http.get(
      `${this.configDirectory}/info-sites/` + data.view + this.translateService.language.toLowerCase() + '.html', { responseType: 'text'})
      .subscribe(data => this.html = data);

    this.http.get(
      `${this.configDirectory}/info-sites/` + data.styles + this.translateService.language.toLowerCase() + '.css', { responseType: 'text'})
      .subscribe(data => this.css = data);
  }
}
